/** Default site copilot for Inter Labs (Jose). */
export const DEFAULT_COPILOT = {
  label: 'Jose',
  value: 'ea6da159-7ecf-4e5b-a5bf-97b2990cc33c',
  icon: 'https://feedalabs-agent-icon.s3.eu-north-1.amazonaws.com/jose_8a09cca9840b4658b0fc24e246525d47.jpg',
  mode: 'agent',
};

export const DEFAULT_COPILOT_ID = DEFAULT_COPILOT.value;
export const DEFAULT_COPILOT_NAME = DEFAULT_COPILOT.label;
export const DEFAULT_COPILOT_ICON = DEFAULT_COPILOT.icon;

export function isDefaultCopilot(agent) {
  if (!agent) return false;
  const id = agent.value ?? agent.id ?? agent.agent_id;
  const name = (agent.label || agent.agent_name || '').toLowerCase().trim();
  return (
    String(id) === DEFAULT_COPILOT_ID ||
    name === 'jose' ||
    name === 'ferdy' ||
    name === 'flo' ||
    name === 'flo chat'
  );
}

export function findDefaultCopilot(agents) {
  if (!agents?.length) return null;
  return (
    agents.find(a => String(a.id ?? a.agent_id) === DEFAULT_COPILOT_ID) ||
    agents.find(a => {
      const name = (a.agent_name || '').toLowerCase().trim();
      return name === 'jose';
    }) ||
    null
  );
}

/** Map an API agent to a select/context option; brand the default as Jose. */
export function toDefaultAwareAgentOption(agent) {
  if (!agent) return null;
  const value = agent.id ?? agent.agent_id ?? agent.value;
  const isDefault = String(value) === DEFAULT_COPILOT_ID || isDefaultCopilot(agent);
  if (isDefault) {
    return {
      label: DEFAULT_COPILOT_NAME,
      value: DEFAULT_COPILOT_ID,
      icon: DEFAULT_COPILOT_ICON,
      mode: 'agent',
    };
  }
  return {
    label: agent.agent_name || agent.label,
    value,
    icon: agent.icon ?? null,
    mode: agent.mode || 'agent',
  };
}
